import React from 'react';
import * as clientActions from '../actions/client';
import { connect } from 'react-redux';
import { withRouter, Redirect } from 'react-router-dom';
import LoadingScreen from '../components/LoadingScreen';
import LoginForm from '../components/forms/LoginForm';
import LOGO from '../logo.svg';
import { getRedirectDomain } from '../services/client';
import features from '../services/daara-config.json';
import LanguageSelector from '../components/LanguageSelector';
import { appConfig } from '../config/appConfig';
import { withTranslation } from 'react-i18next';

class LoginContainer extends React.Component {
    componentDidMount() {
        const { dispatch } = this.props;
        if (features.account_service.auth) {
            return dispatch(clientActions.authClient('https://' + window.location.host));
        }
        dispatch(clientActions.authClient('http://' + window.location.host));
    }

    renderLoading = () => {
        return <LoadingScreen />;
    };

    onFormSubmit = (values, dispatch, props) => {
        dispatch(clientActions.loginClient(values.email, values.password, props.history));
    };

    render() {
        const { isFetching, checked, authenticated, error, t } = this.props;

        if (isFetching) return this.renderLoading();

        if (checked && authenticated) return <Redirect to="/dashboard" />;

        return (
            <div className="container">
                {appConfig.languageOption && <LanguageSelector />}
                <div className="login_form">
                    <div className="form_logo">
                        <a href="/">
                            <img
                                src={`/img/${appConfig.logoName}.svg`}
                                alt={t("common.imageLogoAltText", { companyName: appConfig.companyName })}
                                style={{ width: '100%' }}
                            />
                        </a>
                        <p id="divider">&nbsp;|&nbsp;</p>
                        <p>{t("login.forCompanies")}</p>
                    </div>
                    <div
                        style={{
                            padding: '10px',
                            backgroundColor: 'red',
                            color: 'white',
                            visibility: !isFetching && error.message ? 'visible' : 'hidden'
                        }}
                    >
                        {error.message}
                    </div>
                    <div className="form_wrapper">
                        <LoginForm onSubmit={this.onFormSubmit} />
                    </div>
                    <br />
                    <p className="text_left">
                        {t("login.forgotPassword")}
                        <span className="mini_cta">
                            <a
                                href={`https://${getRedirectDomain(
                                    'accounts'
                                )}/login?fp=1&r=https://${window.location.host}/login`}
                            >
                                {t("login.forgotPasswordLinkLabel")}
                            </a>
                        </span>
                    </p>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { isFetching, error } = state.client || {};
    const { checked, authenticated } = state.session || {};
    return { isFetching, error, checked, authenticated };
}
const LoginContainerWithTranslation = withTranslation()(LoginContainer);
export default withRouter(connect(mapStateToProps)(LoginContainerWithTranslation));
